/* MadMouse — Product page:
   - Gallery (thumb click → swap active frame)
   - Quantity stepper
   - Variant picker (radios) → update hidden id + price + add-to-bag label
*/
(function () {
  if (typeof window === 'undefined') return;
  var roots = document.querySelectorAll('[data-mm-product]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    /* ===== Gallery ===== */
    var applyVariantMedia = null;  /* asignado abajo; lo llama el variant picker */
    var frames = root.querySelectorAll('[data-mm-gallery-frame]');
    var thumbs = root.querySelectorAll('[data-mm-gallery-thumb]');
    if (frames.length) {
      var allFrames = Array.prototype.slice.call(frames);
      var allThumbs = Array.prototype.slice.call(thumbs);

      var setActive = function (idx) {
        allFrames.forEach(function (f) {
          var on = +f.dataset.index === idx;
          f.classList.toggle('is-active', on);
          if (on) f.removeAttribute('aria-hidden'); else f.setAttribute('aria-hidden', 'true');
        });
        allThumbs.forEach(function (t) {
          var on = +t.dataset.index === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      };

      allThumbs.forEach(function (t) {
        t.addEventListener('click', function () { setActive(+t.dataset.index); });
      });

      /* Índices de frames visibles (no ocultos por filtro de variante) */
      var visibleIndices = function () {
        return allFrames
          .filter(function (f) { return !f.classList.contains('is-hidden'); })
          .map(function (f) { return +f.dataset.index; });
      };
      var getActiveIdx = function () {
        var f = root.querySelector('[data-mm-gallery-frame].is-active');
        return f ? +f.dataset.index : 0;
      };
      var navTo = function (delta) {
        var vis = visibleIndices();
        if (!vis.length) return;
        var pos = vis.indexOf(getActiveIdx());
        if (pos === -1) pos = 0;
        var np = pos + delta;
        if (np < 0) np = vis.length - 1;
        if (np >= vis.length) np = 0;
        setActive(vis[np]);
      };

      /* Keyboard arrows on the thumb strip (solo entre visibles) */
      var strip = root.querySelector('[data-mm-gallery-thumbs]');
      if (strip) {
        strip.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
          navTo((e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 1);
          var act = root.querySelector('[data-mm-gallery-thumb].is-active');
          if (act) act.focus();
          e.preventDefault();
        });
      }

      var prevBtn = root.querySelector('[data-mm-gallery-prev]');
      var nextBtn = root.querySelector('[data-mm-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { navTo(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { navTo(1); });

      /* ===== Filtrado de galería por variante =====
         Cada frame/thumb lleva data-variant-ids="id|id|" (vacío = compartida).
         - Oculta las fotos específicas de OTRAS variantes (las compartidas siempre se ven).
         - jumpToLast=true → activa la última foto propia de la variante (los Skates). */
      var parseVids = function (el) {
        return (el.getAttribute('data-variant-ids') || '').split('|').filter(function (x) { return x !== ''; });
      };
      applyVariantMedia = function (variantId, jumpToLast) {
        variantId = String(variantId);
        var lastMatch = -1;
        var toggle = function (el) {
          var vids = parseVids(el);
          var owns = vids.indexOf(variantId) !== -1;
          var show = vids.length === 0 || owns;
          el.classList.toggle('is-hidden', !show);
          return owns;
        };
        allFrames.forEach(function (f) { if (toggle(f)) lastMatch = +f.dataset.index; });
        allThumbs.forEach(function (t) { toggle(t); });

        if (jumpToLast) {
          /* Si la variante muestra fotos addon (Glass Skates), salta a la PRIMERA
             (data-mm-addon-primary). Si no, a la última propia de la variante. */
          var primary = root.querySelector('[data-mm-gallery-frame][data-mm-addon-primary]:not(.is-hidden)');
          if (primary) {
            setActive(+primary.dataset.index);
          } else if (lastMatch >= 0) {
            setActive(lastMatch);
          } else {
            var actJ = root.querySelector('[data-mm-gallery-frame].is-active');
            if (!actJ || actJ.classList.contains('is-hidden')) {
              var visJ = visibleIndices();
              if (visJ.length) setActive(visJ[0]);
            }
          }
        } else {
          var act = root.querySelector('[data-mm-gallery-frame].is-active');
          if (!act || act.classList.contains('is-hidden')) {
            var vis = visibleIndices();
            if (vis.length) setActive(vis[0]);
          }
        }
      };
    }

    /* ===== Lightbox / zoom ===== */
    var lightbox = document.querySelector('[data-mm-pdp-lightbox]');
    var lightboxImg = lightbox && lightbox.querySelector('[data-mm-pdp-lightbox-img]');
    var lightboxClose = lightbox && lightbox.querySelector('[data-mm-pdp-lightbox-close]');
    var zoomBtn = root.querySelector('[data-mm-gallery-zoom]');
    if (lightbox && lightboxImg && zoomBtn) {
      var openZoom = function () {
        var activeFrame = root.querySelector('[data-mm-gallery-frame].is-active');
        if (!activeFrame) return;
        var srcImg = activeFrame.querySelector('img');
        if (!srcImg) return;
        /* Prefer the largest available srcset URL */
        var src = srcImg.currentSrc || srcImg.src;
        lightboxImg.src = src;
        lightboxImg.alt = srcImg.alt || '';
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('mm-pdp-lightbox-open');
      };
      var closeZoom = function () {
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('mm-pdp-lightbox-open');
      };
      zoomBtn.addEventListener('click', openZoom);
      if (lightboxClose) lightboxClose.addEventListener('click', closeZoom);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeZoom();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeZoom();
      });
    }

    /* ===== Qty stepper ===== */
    var qty = root.querySelector('[data-mm-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      var dec = qty.querySelector('[data-mm-qty-dec]');
      var inc = qty.querySelector('[data-mm-qty-inc]');
      var clamp = function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        input.value = v;
      };
      dec && dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); clamp(); });
      inc && inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; clamp(); });
      input && input.addEventListener('blur', clamp);
    }

    /* ===== Floating color switch — show only when inline selector leaves viewport ===== */
    var inlineColor = root.querySelector('.mm-pdp__color');
    var floatingSwitch = root.querySelector('[data-mm-pdp-switch]');
    if (inlineColor && floatingSwitch) {
      var switchIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          floatingSwitch.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      switchIO.observe(inlineColor);
    }

    /* ===== Sticky mobile buy bar =====
       IntersectionObserver on the main buy box. When out of view, slide up the
       fixed bottom bar; when back in view, slide down. Mobile-only via CSS. */
    var sticky = document.querySelector('[data-mm-pdp-sticky]');
    var mainBuyBox = root.querySelector('.mm-pdp__form');
    if (sticky && mainBuyBox) {
      var stickyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      stickyIO.observe(mainBuyBox);
    }

    /* ===== Variant picker =====
       Reads window.MMProduct (injected by liquid) for variant→price lookup.
       Updates hidden id input, displayed price, and add-to-bag availability. */
    var variantInputs = root.querySelectorAll('[data-mm-variant-input]');
    var idField = root.querySelector('[data-mm-variant-id]');
    var priceEl = root.querySelector('[data-mm-price]');
    var priceMirror = root.querySelector('[data-mm-price-mirror]');
    var addBtn = root.querySelector('[data-mm-add]');
    var addLabel = root.querySelector('[data-mm-add-label]');
    var skuEl = root.querySelector('[data-mm-sku]');
    var skuRow = root.querySelector('[data-mm-sku-row]');
    var data = window.MMProduct;

    if (!variantInputs.length || !idField || !data) return;

    var findVariant = function () {
      var selected = [];
      variantInputs.forEach(function (i) { if (i.checked) selected.push(i.value); });
      /* Group inputs by option name in DOM order; map to variant.options[] */
      var optionNames = [];
      variantInputs.forEach(function (i) {
        var match = i.name.match(/options\[(.+?)\]/);
        if (match && optionNames.indexOf(match[1]) === -1) optionNames.push(match[1]);
      });
      /* Build ordered selected array based on option names */
      var ordered = optionNames.map(function (name) {
        var input = root.querySelector('input[name="options[' + name + ']"]:checked');
        return input ? input.value : null;
      });
      return data.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === ordered[i]; });
      });
    };

    var formatMoney = function (cents) {
      // Usa el formato de moneda de Shopify (mismo que el render server con | money),
      // respetando el símbolo/colocación de la divisa. No hardcodear € → multi-divisa.
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, data.money_format);
      }
      var amt = (cents / 100).toFixed(2);
      return amt + ' ' + (data.currency || '€');
    };

    var update = function () {
      var v = findVariant();
      if (!v) return;
      idField.value = v.id;
      if (applyVariantMedia) applyVariantMedia(v.id, true);
      var formatted = formatMoney(v.price);
      if (priceEl) priceEl.textContent = formatted;
      if (priceMirror) priceMirror.textContent = formatted;
      if (addBtn && addLabel) {
        if (v.available) {
          addBtn.removeAttribute('disabled');
          addBtn.removeAttribute('aria-disabled');
          addLabel.textContent = data.labels.add_to_bag;
        } else {
          addBtn.setAttribute('disabled', '');
          addBtn.setAttribute('aria-disabled', 'true');
          addLabel.textContent = data.labels.sold_out;
        }
      }
      if (skuEl) {
        var sku = v.sku || '';
        skuEl.textContent = sku;
        if (skuRow) skuRow.style.display = sku ? '' : 'none';
      }
    };

    variantInputs.forEach(function (i) { i.addEventListener('change', update); });

    /* Filtrado inicial según la variante seleccionada (sin saltar a Skates) */
    if (applyVariantMedia) applyVariantMedia(idField.value, false);
  });
})();
